import {
  configureStore,
  combineReducers,
  UnknownAction,
} from '@reduxjs/toolkit'

import { getInitialAuthState } from './auth'
import { authReducer } from './auth'
import { configurationReducer } from './configuration'
import { countriesReducer } from './countries'
import { culturesReducer } from './cultures'
import { currenciesReducer } from './currencies'
import { languagesReducer } from './languages'
import { modalsReducer } from './modals'
import { notificationsReducer } from './notifications'
import { participantLabelsReducer } from './participantLabels'
import { publishedListingsReducer } from './publishedListings'
import { publishedProjectsReducer } from './publishedProjects'
import { spamReducer } from './spam'
import { translationReducer } from './translation'
import { userReducer } from './user'

const appReducer = combineReducers({
  auth: authReducer,
  configuration: configurationReducer,
  translation: translationReducer,
  user: userReducer,
  countries: countriesReducer,
  currencies: currenciesReducer,
  cultures: culturesReducer,
  languages: languagesReducer,
  publishedListings: publishedListingsReducer,
  publishedProjects: publishedProjectsReducer,
  spam: spamReducer,
  participantLabels: participantLabelsReducer,
  modals: modalsReducer,
  notifications: notificationsReducer,
})

const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: UnknownAction
) => {
  if (action.type === 'APP/RESET') {
    const resetState = appReducer(undefined, { type: '@@INIT' })
    return {
      ...resetState,
      auth: getInitialAuthState(),
      countries: state?.countries ?? resetState.countries,
      currencies: state?.currencies ?? resetState.currencies,
      cultures: state?.cultures ?? resetState.cultures,
      languages: state?.languages ?? resetState.languages,
      translation: state?.translation ?? resetState.translation,
    }
  }
  return appReducer(state, action)
}

export const store = configureStore({
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  reducer: rootReducer,
})

export const resetAppState = () => store.dispatch({ type: 'APP/RESET' })

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof appReducer>
